import React from "react";
import { TablePagination } from "../TablePagination";
import { InfiniteScrollControls } from "../InfiniteScrollControls";
import { useSimpleTableContext } from "../../../contexts/SimpleTableContext";
import type { BaseEntity } from "../../../types";

/**
 * Renders pagination or infinite scroll controls section
 * Shows either traditional pagination or infinite scroll controls based on configuration
 * Consumes data directly from SimpleTableContext
 */
export function SimpleTablePaginationSection<TData extends BaseEntity>() {
  const context = useSimpleTableContext<TData>();
  
  const {
    loadMore,
    hasNextPage,
    isFetchingNextPage,
    totalPages,
    propTotalItems,
    paginatedData,
    processedData,
    state,
    propOnPageChange,
    data,
  } = context;

  const {
    effectiveCurrentPage,
    effectivePageSize,
    effectiveSetCurrentPage,
    effectiveSetPageSize,
  } = state;

  return (
    <>
      {/* Pagination - Only show if not using infinite scroll */}
      {!loadMore && (
        <TablePagination
          totalPages={totalPages}
          propTotalItems={propTotalItems ?? 0}
          paginatedData={paginatedData}
          processedData={processedData}
          effectiveCurrentPage={effectiveCurrentPage}
          effectivePageSize={effectivePageSize}
          effectiveSetCurrentPage={effectiveSetCurrentPage}
          effectiveSetPageSize={effectiveSetPageSize}
          propOnPageChange={propOnPageChange}
          infiniteScrollEnabled={loadMore ? true : false}
        />
      )}

      {/* Infinite Scroll Controls - Only show if loadMore is provided */}
      {loadMore && (
        <InfiniteScrollControls
          loadMore={loadMore}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          data={data}
        />
      )}
    </>
  );
}
